import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import * as React from 'react';

export class PickupCell extends React.Component<GridCustomCellProps> {
  public render() {
    return (
      <td {...this.props.tdProps}>
        {this.props.dataItem.PickupLocation}<br />
        {dayjs.utc(this.props.dataItem.PickupDateTime).tz("America/New_York").format('MM/DD/YYYY HH:mm')}<br />
        {this.props.dataItem.LaneName}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    if (nextProps.dataItem.Hash === this.props.dataItem.Hash) {
      return false;
    }

    return true;
  }
}
